﻿window.cBuilderEmailWidgetCtrlWeb = function cBuilderEmailWidgetCtrlWeb(option) {
    var Me = this;

    window.cBuilderEmailWidgetCtrlTextBox.call(this, option);

    this.nomWidget = "dxwidgetformtextboxsiteweb"
    this.typChamp = "site_web";
    this.nomBt = "Site internet";
    this.titleBt = "Site internet"
    this.labelCtrl = "Site internet"

};